// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DribbbleOutlinedSvg from "@fishx/icons-svg/es/asn/DribbbleOutlined";
import FishxIcon from '../components/FishxIcon';

var DribbbleOutlined = function DribbbleOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DribbbleOutlinedSvg
  }));
};

DribbbleOutlined.displayName = 'DribbbleOutlined';
export default React.forwardRef(DribbbleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DribbbleOutlined.js
// module id = 2478
// module chunks = 0